import React from "react";
import DOMPurify from "dompurify";
const SafeHTMLRenderer = ({ html, className }) => {
  const sanitizedHTML = DOMPurify.sanitize(html || "");
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};
export default SafeHTMLRenderer;